/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAiCredentialsQueryResponse, ListAiCredentialsPathParams, ListAiCredentials400, ListAiCredentials401, ListAiCredentials403, ListAiCredentials404, ListAiCredentials409, ListAiCredentials500 } from "../../types/platformBillingController/ListAiCredentials.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAiCredentials } from "../../client/platformBillingController/listAiCredentials.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAiCredentialsQueryKey = (organizationId: ListAiCredentialsPathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/platform-billing/credentials', params: {organizationId:organizationId} }] as const

export type ListAiCredentialsQueryKey = ReturnType<typeof listAiCredentialsQueryKey>

export function listAiCredentialsQueryOptions(organizationId: ListAiCredentialsPathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAiCredentialsQueryKey(organizationId)
        return queryOptions<ListAiCredentialsQueryResponse, ResponseErrorConfig<ListAiCredentials400 | ListAiCredentials401 | ListAiCredentials403 | ListAiCredentials404 | ListAiCredentials409 | ListAiCredentials500>, ListAiCredentialsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAiCredentials(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List masked BYOK provider credentials
 * {@link /api/organizations/:organizationId/platform-billing/credentials}
 */
export function useListAiCredentials<TData = ListAiCredentialsQueryResponse, TQueryData = ListAiCredentialsQueryResponse, TQueryKey extends QueryKey = ListAiCredentialsQueryKey>(organizationId: ListAiCredentialsPathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ListAiCredentialsQueryResponse, ResponseErrorConfig<ListAiCredentials400 | ListAiCredentials401 | ListAiCredentials403 | ListAiCredentials404 | ListAiCredentials409 | ListAiCredentials500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAiCredentialsQueryKey(organizationId)
         

         const query = useQuery({
          ...listAiCredentialsQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAiCredentials400 | ListAiCredentials401 | ListAiCredentials403 | ListAiCredentials404 | ListAiCredentials409 | ListAiCredentials500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}